import {Controller, useFormContext} from "react-hook-form";
import {IconButton, InputAdornment, TextField} from "@mui/material";
import PropTypes from "prop-types";
import React, {useState} from "react";
import {Visibility, VisibilityOff} from "@mui/icons-material";
import { checkPasswordStrength } from "@/Utils/Common";
import {useTranslation} from "@/Utils/CustomHooks/useTranslation";

InputPasswordCheck.propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    fieldAction: PropTypes.object,
    disabled: PropTypes.bool,
    helperText: PropTypes.string
};
// @ts-ignore
export default function InputPasswordCheck({name, label, disabled, fieldAction, helperText}) {
    const {
        control,
        formState: {isSubmitting},
    } = useFormContext();
    const [showPassword, setShowPassword] = useState(false);
    const {t} = useTranslation();



    if (fieldAction?.name && !fieldAction?.visible) {
        return <></>
    }

    return (
        <Controller
            name={name}
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => {
                return (
                    <>
                        <TextField
                            data-testid={`${name}-input`}
                            sx={
                                !showPassword
                                    ? {
                                        "& input": {
                                            textSecurity: "disc",
                                            "MozTextSecurity": "disc",
                                            "WebkitTextSecurity": "disc",
                                        },
                                    }
                                    : {}
                            }
                            autoComplete={"off"}
                            InputProps={{
                                autoComplete: "off", // disable autocomplete and autofill
                                endAdornment: (
                                    <InputAdornment position={"start"}>
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={() => {
                                                setShowPassword(!showPassword);
                                            }}
                                            edge="end"
                                        >
                                            {showPassword ? (
                                                <Visibility/>
                                            ) : (
                                                <VisibilityOff/>
                                            )}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                            label={label}
                            fullWidth
                            size={"small"}
                            onChange={(event) => {
                                onChange(event);
                            }}
                            error={!!error}
                            disabled={isSubmitting || disabled || fieldAction?.disabled}
                            value={value}
                            helperText={helperText ?? error?.message}
                            margin={"dense"}

                        />

                        {value?.length > 0 && (
                            <>
                                <div
                                    style={{
                                        display: "flex",
                                        gap: "4px",
                                        marginTop: "6px",
                                        width: "100%",
                                    }}
                                >
                                    {[0, 1, 2, 3].map((index) => {
                                        const score = checkPasswordStrength(value).score;

                                        let color = "#ddd";

                                        if (index < score) {
                                            if (score === 1) {
                                                color = "#d32f2f";
                                            } else if (score === 2) {
                                                color = "#ed6c02";
                                            } else if (score === 3) {
                                                color = "#f9a825";
                                            } else if (score === 4) {
                                                color = "#2e7d32";
                                            }
                                        }

                                        return (
                                            <div
                                                key={index}
                                                style={{
                                                    flex: 1,
                                                    height: "4px",
                                                    borderRadius: "2px",
                                                    backgroundColor: color,
                                                }}
                                            />
                                        );
                                    })}
                                </div>

                                <div
                                    style={{
                                        marginTop: "5px",
                                        fontSize: "0.8rem",
                                        color:
                                            checkPasswordStrength(value).score <= 1
                                                ? "#d32f2f"
                                                : checkPasswordStrength(value).score === 2
                                                    ? "#ed6c02"
                                                    : checkPasswordStrength(value).score === 3
                                                        ? "#f9a825"
                                                        : "#2e7d32",
                                        textAlign: "right",
                                    }}
                                >
                                    {checkPasswordStrength(value).score <= 1
                                        ? t("userToken.passwordStrength.weak")
                                        : checkPasswordStrength(value).score === 2
                                            ? t("userToken.passwordStrength.medium")
                                            : checkPasswordStrength(value).score === 3
                                                ? t("userToken.passwordStrength.good")
                                                : t("userToken.passwordStrength.strong")}
                                </div>
                            </>
                        )}
                    </>

                );
            }}
        />
    );
}
